/** Bare roles with their `system`, `{client code}`, or `{client code}_{design code}` removed. */
export enum UserCoreRole {
  /** User with access to everything in all services. */
  admin = 'admin',
  /** User with access to everything in D2. */
  designerAdmin = 'designer_admin',
  /** User that designs flows & prompts. */
  designerDesigner = 'designer_designer',
  /** User that codes custom nodes within designs. */
  designerDeveloper = 'designer_developer',
  /** User that tests designs to make sure they are correct. */
  designerQa = 'designer_qa',
  /** User that can see, but not touch. */
  designerViewer = 'designer_viewer'
}

/**
 * Any of these roles is enough for the user to be able to save the design,
 * and look at it as any other userType.
 */
export const EDITOR_ROLES = [
  UserCoreRole.designerDesigner,
  UserCoreRole.designerDeveloper,
  UserCoreRole.designerQa
];
